// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"894aa239","745":"041db536","809":"10fd73e0"}[chunkId] + ".chunk.js";
};